{
  "name": "ccpet",
  "version": "1.1.2",
  "description": "A Claude Code status line script that displays a virtual pet",
  "main": "dist/ccpet.js",
  "bin": {
    "ccpet": "dist/cli.js"
  },
  "files": [
    "/dist",
    "/bin"
  ],
  "scripts": {
    "build": "node esbuild.config.js",
    "watch": "node esbuild.config.js --watch",
    "test": "vitest",
    "test:unit": "vitest run src/core src/ui src/services",
    "test:coverage": "vitest run --coverage",
    "prepublishOnly": "npm run build && tsc --noEmit && npm test",
    "version": "npm run build",
    "postversion": "git push && git push --tags",
    "release:patch": "npm version patch",
    "release:minor": "npm version minor",
    "release:major": "npm version major"
  },
  "devDependencies": {
    "@types/node": "20.10.5",
    "@vitest/coverage-v8": "^3.2.4",
    "esbuild": "0.20.2",
    "prettier": "3.1.1",
    "typescript": "5.3.3",
    "vitest": "^3.2.4"
  },
  "engines": {
    "node": ">=20.0.0",
    "npm": ">=9.0.0"
  },
  "keywords": [
    "claude-code",
    "status-line",
    "ccpet",
    "pet",
    "cli",
    "virtual-pet",
    "productivity"
  ],
  "author": "Claude Code Team",
  "license": "MIT",
  "homepage": "https://github.com/terryso/ccpet#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/terryso/ccpet.git"
  },
  "bugs": {
    "url": "https://github.com/terryso/ccpet/issues"
  }
}
